<style >
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.activeClass{
  background: #fff!important;
}
</style>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";

export default {
  page: {
    title: "İşletmeci Veri Formu",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader
  },
  data() {
    return {
            details:[],
            search: true,
            title: "İŞLETMECİ VERİ FORUMU",
            items: [
                {
                    text: "ANASAYFA",
                    href: "/",
                },
                {
                    text: "İŞLETMECİ VERİ FORUMU",
                    active: true,
                },
            ],
            loading: false,
            detailSearch:false,
            form:{},
            rows: {},
            
        };
    },
    mounted(){},
    methods: {
        formSubmit(){
            this.$http.post('/reports/isletmeciVeri', {...this.form})
                .then(response => this.rows = response.data)
        },
        allClear(){
            this.form = {}
        },
        excelExport() {
            this.$http.post('/reports/export/sales',  {...this.form})
            .then((response) => {
                var temp = 'data:application/vnd.ms-excel;base64,'
                    +encodeURIComponent(response.data.content);  
                var download = document.createElement('a');  
                download.href = temp;  
                download.download = response.data.filename;  
                document.body.appendChild(download);  
                download.click();
                document.body.removeChild(download);
            });
        },
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row mb-3">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <form class="needs-validation" @submit.prevent="formSubmit">
                <div class="row">
                    <div class="col-xl-6">
                        <div class="mb-3">
                        <label >Yıl</label>
                            <select 
                                v-model="form.year" 
                                class="form-control form-select" 
                            >
                                <option value="" >{{ new Date().getFullYear() }}</option>
                                <option value="" v-for="v in 3" :key="v">{{ new Date().getFullYear() -v }}</option>
                        </select>
                        </div>
                    </div>
                  <div class="col-xl-6">
                    <div class="mb-3">
                       <label >Dönem</label>
                        <select 
                          v-model="form.ceyrek" 
                          class="form-control form-select" 
                        >
                            <option value="" v-for="v in 4" :key="v">{{ v }}. Çeyrek Dönem</option>
                      </select>
                    </div>
                  </div>
              </div>
              
                <div class="row">
                  <div class="col-md-4 offset-md-8 text-end">
                    <div class="button-items">
                       <button 
                          type="submit"
                          class="btn btn-outline-danger"  
                          @click="allClear()" 
                          >
                          Sorguyu Temizle
                        </button>
                        <button 
                          type="submit"
                          class="btn btn-primary"   
                          >
                           Sorgula
                        </button>
                    </div>
                  </div>
                </div>    
              </form>
              <!-- end card -->
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <Loader :loading="true" :load="loading">
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header">
                     <h5 class="card-title mb-0"><i class="mdi mdi-arrow-right text-primary me-1"></i> 
                       İllere Göre Dağılım</h5>
                </div>
                <div class="card-body">
                    <div class="responsive-table">
                        <table class="table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>İL</th>
                                    <th>DİGER</th>
                                    <th>FİBER</th>
                                    <th>WIFI</th>
                                    <th>TOPLAM</th>
                                </tr>
                            </thead>
                            <tbody></tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header">
                     <h5 class="card-title mb-0"><i class="mdi mdi-arrow-right text-primary me-1"></i> 
                       Firmaya Göre Dağılım</h5>
                </div>
                <div class="responsive-table">
                    <table class="table table-striped table-bordered">
                        <thead>
                            <tr>
                                <th>FİRMA</th>
                                <th>DİĞER</th>
                                <th>FİBER</th>
                                <th>WİFİ</th>
                                <th>TOPLAM</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th>ALT YAPI OLMAYAN</th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th>TÜRK TELEKOM</th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th>KENDİ ALTYAPISI</th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header">
                    Bireysel / Kurumsal Dağılım
                </div>
                <div class="responsive-table">
                    <table class="table table-striped table-bordered">
                        <thead>
                            <tr>
                                <th>FİRMA</th>
                                <th>DİĞER</th>
                                <th>FİBER</th>
                                <th>WİFİ</th>
                                <th>TOPLAM</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th>BIREYSEL</th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th>KURUMSAL</th>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header">
                   Hızlara Göre Dağılım
                </div>
                <div class="responsive-table">
                    <table class="table table-striped table-bordered">
                        <thead>
                            <tr>
                                <th>2 Mbps Ve Altı</th>
                                <th>2 Mbps - 4Mbps </th>
                                <th>4 Mbps - 10 Mbps</th>
                                <th>10 Mbps - 16 Mbps</th>
                                <th>16 Mbps - 24 Mbps</th>
                                <th>24 Mbps - 35 Mbps</th>
                                <th>35 Mbps - 50 Mbps</th>
                                <th>50 Mbps - 100 Mbps</th>
                                <th>100 Üzeri</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header">
                    Toplam Trafik
                </div>
                <div class="responsive-table">
                    <table class="table table-striped table-bordered">
                        <thead>
                            <tr>
                                <th>TOPLAM</th>
                                <th>DOWNLOAD</th>
                                <th>UPLOAD</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th>BIREYSEL</th>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    </Loader>
  </Layout>
</template>